<div class="wizard-full-page-container">
    <div class="wizard-page-container">
        <div class="wizard-left-sidebar hidden lg:block">
            <div class="logo-wizard">
                <img src="/assets/images/timeBuzzer-logo-white.svg" alt="timeBuzzer" />
            </div>

            <div class="wizard-menu-header-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-separator"></div>

            <div class="wizard-menu-header-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-separator"></div>

            <div class="wizard-menu-header-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-separator"></div>

            <div class="wizard-menu-header-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>

            <div class="wizard-menu-item-placeholder"></div>
        </div>
        <div class="wizard-main-container">
            <div class="topbar">
                <div class="rounded"></div>
                <p-divider layout="vertical"></p-divider>
                <p class="wizard-name mr-6">{{ firstName }} {{ lastName }}</p>
            </div>

            <div class="wizard-content pt-20 mt-0 md:mt-20 lg:mt-20 px-8 md:px-20 lg:px-20">
                <div class="steps-progressbar">
                    <div class="step" [ngClass]="currentStep?.stepIndex === 1 ? 'step-active' : ''"></div>
                    <div class="step" [ngClass]="currentStep?.stepIndex === 2 ? 'step-active' : ''"></div>
                    <div class="step" [ngClass]="currentStep?.stepIndex === 3 ? 'step-active' : ''"></div>
                </div>

                @switch (currentStep?.stepIndex) {
                    @case (1) {
                        <app-wizard-first
                            [firstName]="firstName"
                            [lastName]="lastName"
                            (firstNameChange)="firstName = $event"
                            (lastNameChange)="lastName = $event"
                        />
                    }
                    @case (2) {
                        <app-wizard-second />
                    }
                    @case (3) {
                        <app-wizard-third />
                    }
                    @default {
                        <p-message severity="error">Error: wizard step not provided</p-message>
                    }
                }
            </div>
        </div>
    </div>
</div>
